import React from "react";
import { Col, Input } from "reactstrap";
// Used by MachineSetups in the same components folder

export default function ColPromptCheckBox({
   title,
   valuePRP,
   callBack,
   alignPRP,
   sizePRP,
}) {
   //   const MachUpdater = useMachineSetupContextUpdater();
   const alignment = !alignPRP ? "left" : alignPRP;

   if (!alignPRP) {
      return (
         <Col
            xs={sizePRP || "3"}
            className="d-flex justify-content-between align-items-center mb-3 px-4 text-white"
         >
            <h5 style={{ textAlign: alignment }}>{title}</h5>
            <Input
               type="checkbox"
               value={valuePRP}
               onChange={() => callBack()}
               checked={valuePRP}
            />
         </Col>
      );
   } else {
      return (
         <Col
            xs={sizePRP || "3"}
            className="d-flex justify-content-start align-items-center mb-3 px-5 text-white"
            style={{ textAlign: "left" }}
         >
            <Input
               type="checkbox"
               value={valuePRP}
               onChange={() => callBack()}
               checked={valuePRP}
            />
            &nbsp;&nbsp;&nbsp;
            <h5 style={{ textAlign: alignment, paddingTop: "1vh" }}>{title}</h5>
         </Col>
      );
   }
}
